/* eslint-disable import/extensions,import/no-unresolved,import/no-duplicates */
import { itineraryChangeLookup as expenseLookup } from './claimCodeMapper';

function mapToParentSection() {
  return {};
}

function mapToQuestionnaire() {
  return [];
}

function mapToExpenses(data) {
  const medicalExpenses = mapToMedicalExpenseStep(data);

  return [...medicalExpenses];
}

function mapToMedicalExpenseStep(data) {
  const expenses = [];
  if (data.itineraryChange !== 'true' && data.lossInformationItems.length < 1) {
    return expenses;
  }
  const claimCode = expenseLookup.itineraryChange.claimCode;
  data.lossInformationItems.forEach(
    (item) => {
      const expense = mapLossItemExpense(item, data, claimCode);
      if (!!expense) {
        expenses.push(expense);
      }
      const reimburseExpense = mapReimbursement(item, data, claimCode);
      if (!!reimburseExpense) {
        expenses.push(reimburseExpense);
      }
    }
  );
  return expenses;
}

function mapLossItemExpense(item, formData, claimCode) {
  return mapExpenseItem(item, formData.dateIncurred, claimCode);
}

function mapExpenseItem(item, itemDate, claimCode) {
  if (!item || !item.amountClaimed || !item.currentAmountClaimed) {
    return null;
  }
  return {
    shortDescription: `${item.companyNameLoss}`,
    dateOfExpense: item.dateIncurred,
    clientCost: item.amountClaimed,
    currency: item.currentAmountClaimed,
    rate: null,
    requestedAmount: null,
    claimTypeCode: claimCode,
  };
}

function mapReimbursement(item, formData, claimCode) {
  if (!item || !item.howMuchReceivedReimbursement || !item.currentReceivedReimbursement || item.haveYouReceivedReimbursement !== 'true') {
    return null;
  }
  return {
    shortDescription: `${item.fromWhomReceivedReimbursement} (Reimbursement)`,
    dateOfExpense: item.dateReimbursementReceived,
    clientCost: `${item.howMuchReceivedReimbursement * -1}`,
    currency: item.currentReceivedReimbursement,
    rate: null,
    requestedAmount: null,
    claimTypeCode: claimCode,
  };
}

export default {
  mapToParentSection,
  mapToQuestionnaire,
  mapToExpenses,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/stepItineraryChangeDataMapper.js